export enum Entities {
  System = "system",
  Users = "users",
  Responses = "surveyResponses",
  Surveys = "surveys",
  Feedback = "feedback",
}
